import { render, staticRenderFns } from "./ListaLibros.vue?vue&type=template&id=5d7d9cb8"
import script from "./ListaLibros.vue?vue&type=script&lang=js"
export * from "./ListaLibros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports